import { createSelector } from 'reselect';
import getPropFromModule from './getPropFromModule';
import { DATA } from '../model';

const getGlobalDiscountsMenu = createSelector(
  state => getPropFromModule(state, DATA),
  data => data?.toMap().toJS().globalDiscounts || null,
);
export default getGlobalDiscountsMenu;
